<style lang="stylus" scoped>
.not_foundwrap
  text-align center
  background #fff
  padding: 50px 0 0px
</style>

<template>
  <div class="not_foundwrap appwrap topMargin">
    <img src="/static/img/404.png" alt="404页面没找到">
  </div>
</template>

<script>

export default {
  name: 'NotFound'
}
</script>


// WEBPACK FOOTER //
// src/components/notFound/index.vue